import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import { CentrosAdapter, CentroUser } from '../../../../../infraestructure/persistence/rest/CentrosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { Screen } from './screen';

export const ListaCentrosContainer = forwardRef((props:any, ref:any) => {
	
	const {user} = props
	const api = new CentrosAdapter();
	const { exceptionError, resultError } = useNotifications();
	let [centros, setCentros] = useState<any>([]);
	let [centrosUser, setCentrosUser] = useState<any>([]);
	let result: any;
  
	useEffect(()=>{
		getCentros();
		if(user && user.tieneCentros){getCentrosUser(user)}
	},[])

	const getCentros = async () => {
		try {
			result = await api.ListarCentros();
			if(result.data && result.data!=="")
			{
				setCentros([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  	};

	const getCentrosUser = async (user:any) => {
		try {
			result = await api.ListarCentrosUsuario(user.login);
			if(result.data && result.data!=="")
			{
				setCentrosUser([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  	};

	const getDataUser = useMemo(()=> centrosUser.map((cu:CentroUser)=> cu),[centrosUser])

  return <Screen data={centros} dataUser={getDataUser} ref={ref} menu/>;
});

export default ListaCentrosContainer;